<template>
	<div class="main">
		<div class="mainIn">
			<el-col v-if="modelData.accesses.add" :span='24' style="text-align: right;padding-right: 20px;margin-bottom: 10px;">
				<el-button type="primary" size="small" @click="addSession()">添加</el-button>
			</el-col>
			<el-table :data="tableData" style="width: 100%;border: 1px;" border highlight-current-row header-cell-style="background: #eee;color:#999;">
				<el-table-column label-class-name="verify_item" prop="dtOn" label="日期" width="160" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.dtOn}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-date-picker class="input_width_140" :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="scope.row.dtOn" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column label-class-name="verify_item" prop="timeStart" label="开始时间" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.timeStart}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-time-select class="input_width_100" v-model="scope.row.timeStart" :picker-options="{
	                            start: '00:00',
	                            step: '00:05',
	                            end: '23:55'
	                        }" placeholder="选择时间">
						</el-time-select>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column label-class-name="verify_item" prop="timeEnd" label="结束时间" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.timeEnd}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-time-select class="input_width_100" v-model="scope.row.timeEnd" :picker-options="{
	                            start: '00:00',
	                            step: '00:05',
	                            end: '23:55'
	                        }" placeholder="选择时间">
						</el-time-select>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column label-class-name="verify_item" prop="topic" label="主题" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.topic}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-input v-model="scope.row.topic"></el-input>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column label-class-name="verify_item" prop="place" label="地点" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.place}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-input v-model="scope.row.place"></el-input>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column v-if="modelData.hasSpeaker" prop="speaker" label="讲者姓名" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.speaker}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading" @click.native="getSpeaker()">
							<!--<el-input v-model="scope.row.speaker"></el-input>-->
							<popover-table class="public_font" inputWidth="100px" :placement="'left'" :popoverWidth="600" v-model="scope.row.speaker" selectField="name" :tableTitle="speakerListTitle" :tableData="speakerList" :total="total" :pageSize="5" :pageIndex="pageIndex" :inputSearch="getSpeaker">
							</popover-table>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column v-if="modelData.hasSpeaker" prop="speakerTimeStart" label="讲授开始时间" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.speakerTimeStart}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-time-select class="input_width_100" v-model="scope.row.speakerTimeStart" :picker-options="{
	                            start: '00:00',
	                            step: '00:05',
	                            end: '23:55'
	                        }" placeholder="选择时间">
						</el-time-select>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column v-if="modelData.hasSpeaker" prop="speakerTimeEnd" label="讲授结束时间" width="120" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.speakerTimeEnd}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-time-select class="input_width_100" v-model="scope.row.speakerTimeEnd" :picker-options="{
	                            start: '00:00',
	                            step: '00:05',
	                            end: '23:55'
	                        }" placeholder="选择时间">
						</el-time-select>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column label-class-name="verify_item" prop="content" label="会议内容" width="180" align="center">
					<template slot-scope="scope">
						<span v-if="!scope.row.isEdit && loading">{{scope.row.content}}</span>
						<el-col :span="24" v-if="scope.row.isEdit && loading">
							<el-input v-model="scope.row.content"></el-input>
						</el-col>
					</template>
				</el-table-column>
				<el-table-column v-if="modelData.accesses.edit || modelData.accesses.remove" prop="address" label="操作" fixed="right" align="center" min-width="150">
					<template slot-scope="scope">
						<el-button v-if="modelData.accesses.edit" :type="scope.row.isEdit ? 'success' : 'primary'" size="mini" @click="editSession(scope.row)">{{scope.row.isEdit?"保存":"编辑"}}</el-button>
						<el-button v-if="modelData.accesses.remove" type="danger" size="mini" @click="removeSession(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-row class="footer">
				<el-button class="width100 falseBtn" v-on:click.native="doAsync(false)">
					取消
				</el-button>
				<el-button class="width100 sureBtn" :loading="btnLoading" v-on:click.native="doAsync(true)">
					确定
				</el-button>
			</el-row>
		</div>
	</div>
</template>

<script>
	import popoverTable from './popoverTable';
	import sessionEditor from "@scripts/components/sessionEditor.js";
	import { iStorage } from 'smart-core-util';
	export default {
		extends: sessionEditor,
		components: {
			popoverTable
		},
		data() {
			return {
				doType: true,
				modelData: {},
				pickerOptions: {
					disabledDate(time) {
						//			        	return time.getTime() < Date.now();
					}
				},
				tableData:[],
				loading:true,
				speakerListTitle: [{
					titleId: 'name',
					titleText: '姓名'
				}, {
					titleId: 'uci',
					titleText: 'UCI编号'
				}, {
					titleId: 'hospital',
					titleText: '医院'
				}, {
					titleId: 'section',
					titleText: '科室'
				}, {
					titleId: 'email',
					titleText: '邮箱'
				}, {
					titleId: 'phoneNumber',
					titleText: '手机号'
				}],
				pageIndex:1,
				pageSize:5,
				keyword:'',
				total:0,
				btnLoading: false
			};
		},
		watch: {
			modelData: {
				handler: "listenModelData",
				deep: true
			},
		},
		created() {
			//			window.addEventListener("message", this.getSession, false);
			this.getSession();
		},
		methods: {
			async getSpeaker(obj) {
				if(obj){
					this.keyword = obj.keyword || '';
		            this.pageIndex = obj.pageIndex || 1;
		            this.pageSize = obj.pageSize || 5;
				}
				var params = {
					marker: this.keyword,
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
					noCount: false,
					miceId: this.iStorage.get("proposalId"),
					source: '' //添加签到人员，需要过滤已签到的人员
				};
				let response = await this.api.post(this.url.mice.HcpInfoPaging, params);
				if(response && response.success) {
					this.speakerList = response.content.rows;
					this.total = response.content.total;
				}
			},
			editSession(row){
				this.loading = false;
				if(row.isEdit){
					if(this.verifyMthod(null,row)){
						row.isEdit = false;
					}
				}else{
					row.isEdit = true;
				}
				this.loading = true;
			},
			removeSession(row, index){
				this.tableData.splice(index,1)
			},
			addSession(){
				this.model.miceId = this.model.miceId || this.iStorage.get("proposalId"); //防止公共js方法同组件内部执行顺序
				var model = {
					miceId: this.model.miceId,
					dtOn: null, //日期
					timeStart: null, //开始时间
					timeEnd: null, //结束时间
					topic: null, //主题
					place: null, //地点
					content: null, //会议内容
					speaker:null,//讲者姓名
					speakerTimeStart:null,//讲授开始时间
					speakerTimeEnd:null//讲授结束时间
				}
				this.tableData.push(model)
			},
			//日程日期必须在会议期间
			listenModelData() {
				let dtStart = this.modelData.dtStart;
				let dtEnd = this.modelData.dtEnd;
				this.pickerOptions = {
					disabledDate(time) {
						return time.getTime() < new Date(dtStart) || time.getTime() > new Date(dtEnd);
					}
				}
			},
			getSession() {
				this.modelData = this.iStorage.get('model');
				this.iStorage.set('proposalId', this.modelData.miceId);
				this.tableData = this.modelData.taskList;
				this.tableData.map((ele)=>{
					ele.isEdit = false;
				})
				console.log(this.modelData);
				
				if(this.modelData.addType == 'edit') {
					let data = this.modelData;
					this.model.dtOn = data.dtOn.substring(0, 10);
					this.model.timeStart = data.timeStart;
					this.model.timeEnd = data.timeEnd;
					this.model.topic = data.topic;
					this.model.place = data.place;
					this.model.content = data.content;
					this.model.sessionId = data.sessionId;
					this.model.tenantId = data.tenantId;
					this.model.miceId = data.miceId;
				}
			},
			// 执行按钮操作
			async doAsync(type) {
				this.doType = type;
				if(type) {
					this.btnLoading = true
					await this.saveAllAsync({
						onSuccess: (response) => {
							console.log(response)
							this.$message({
								message: '保存成功',
								type: 'success'
							})
							this.postMessage()
						},
						toast: null,
						data:this.tableData,
						hasSpeaker:this.modelData.hasSpeaker
					})
					this.btnLoading = false
				} else {
					this.postMessage();
					return;
				}
			},
			// postMessage
			postMessage() {
				let data = {
					from: "simulator",
					to: "sessionEditor",
					type: this.doType // true关闭后，调用者会执行传递的handler，false关闭后，则不执行。
				};
				window.parent.postMessage(data, "*");
			}
		}
	};
</script>

<style scoped>
	@import "../assets/css/public.css";
	.input_width_140{
		width: 140px;
	}
	.input_width_100{
		width: 100px;
	}
	.main {
		/*width: 520px;*/
		margin: 0 auto;
		padding: 0 0 50px;
		color: #666666;
		font-size: 16px;
	}
	
	.mainIn {
		padding: 10px 15px;
	}
	
	.item {
		padding: 10px 0;
	}
	
	.footer {
		margin: 20px 0 0;
	}
</style>

<style>
	.public_font {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}
	
	.public_font .el-input__inner {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}
	
	.public_font .el-textarea__inner {
		color: #606266 !important;
		font-size: 14px !important;
		font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
	}
	
	.public_font .el-textarea__inner::-webkit-input-placeholder {
		color: #CCCCCC;
		font-size: 11px;
	}
	
	.public_font .el-textarea__inner:-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}
	
	.public_font .el-textarea__inner::-moz-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}
	
	.public_font .el-textarea__inner:-ms-input-placeholder {
		color: #CCCCCC;
		font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/sessionEditor.vue